// Important, window.innerWidth might be incorrect on document ready
// If you need to know the breakpoint to initialize things, do it on window load instead
const identifyBreakpoint = (width = window.innerWidth) => {
  let breakpoint = 'widescreen';

  if (width < window.theme.breakpoints.mobile) { 
    breakpoint = 'mobile';
  }

  if (width >= window.theme.breakpoints.mobile && width < window.theme.breakpoints.tablet) {
    breakpoint = 'tablet';
  }

  if (width >= window.theme.breakpoints.tablet && width < window.theme.breakpoints.desktop) {
    breakpoint = 'desktop';
  }

  return breakpoint;
};

let previous_breakpoint = identifyBreakpoint();

const breakpoints = () => {
  window.theme.breakpoints.current = previous_breakpoint;

  $(window).on('resize', () => {
    const current_breakpoint = identifyBreakpoint();

    if (current_breakpoint !== previous_breakpoint) {
      previous_breakpoint = current_breakpoint;
      window.theme.breakpoints.current = current_breakpoint;
      $(window).trigger('breakpointHasChanged', current_breakpoint);
      console.log('breakpointHasChanged', window.theme.breakpoints.current);
      // Fire a scroll event to trigger any animations that might need to happen on a breakpoint change
      $(window).trigger('scroll');
    }
  });
};

export { breakpoints };
